module.exports = "/images/mh.svg?d5f17d4435c9ebd93e63eef65f532c00";